import { Button, Divider, Space } from "antd-mobile";
import React from "react";
import { CloseOutline } from 'antd-mobile-icons'
export default function Info(props) {

    const { data = {}, oh = false, search = () => { }, } = props;
    const {
        title = "",
        primary_code = "",

        stock_data = {}
    } = data;

    const {
        backroom = 0,
        rank = 0,
        held_point_of_sale = 0,
        pending_return = 0,
        note = {},

    } = (stock_data) ? stock_data : {};


    const { full_note = "" } = note;


    const extractBracketedText = (str) => {
        const ret = str.match(/\[([^\]]+)\]/g);
        if (ret) {
            return ret.map(item => "[" + item.slice(1, -1) + "]").join(", ");
        } else {
            return [];
        }
    };


    const min_rank = window.minimum_rank || 0;
    const tags = extractBracketedText(full_note);

    const drawImage = (_primary_code) => {
        return (<div className="img-contain" style={{ "backgroundImage": "url('https://bookmanager.com/i/bkmngr_cover/isbn/" + _primary_code + "')" }}></div>)
    }

    return (
        <>
            <div className="float-flex">
                <div>{(stock_data) ? title : "Not in inventory"}</div>
                <div style={{ "width": "30px" }}><CloseOutline /></div>
            </div>

            <Divider />
            <Space>
                <div style={{ "width": "140px" }}>{drawImage(primary_code)}</div>
                <table>

                    {(rank > 0 &&
                        <tr>
                            <td colSpan={2}>
                                <div style={{ "opacity": "0.6" }}>Rank</div>
                                <div><strong>#{rank}</strong></div>
                            </td>
                        </tr>
                    )}

                    {(rank < 0 &&
                         <tr>
                            <td colSpan={2}>
                                <div style={{ "opacity": "0.6" }}>Forthcoming</div>
                                <div><strong>#{Math.abs(min_rank - rank)}</strong></div>
                            </td>
                        </tr>
                    )}



                    {((backroom > 0) &&
                        <tr>
                            <td style={{ "opacity": "0.6" }}>Backroom</td>
                            <td><strong>{backroom}</strong></td>
                        </tr>
                    )}
                    {((held_point_of_sale > 0) &&
                        <tr>
                            <td style={{ "opacity": "0.6" }}>Held POS</td>
                            <td><strong>{held_point_of_sale}</strong></td>
                        </tr>
                    )}
                    {((pending_return > 0) &&
                        <tr>
                            <td style={{ "opacity": "0.6" }}>PendRtns</td>
                            <td><strong>{pending_return}</strong></td>
                        </tr>
                    )}

                    {(tags &&
                        <tr>
                            <td><strong>{tags}</strong></td>
                        </tr>
                    )}

                </table>
            </Space>
            {(oh && <Button onClick={() => search(primary_code)}>Find in context</Button>)}

            {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}


        </>
    )
}